import script from "./CarouselSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselSlide.vue?vue&type=script&setup=true&lang=js"

import "./CarouselSlide.vue?vue&type=style&index=0&id=faf17f68&lang=css"

const __exports__ = script;

export default __exports__